<template>
  <v-breadcrumbs :items="breadcrumbItems">
    <template v-slot:prepend>
      <v-btn icon="mdi-home-outline" density="compact" to="/dashboard" flat class="home-btn">
      </v-btn>
    </template>
  </v-breadcrumbs>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const breadcrumbItems = computed(() => {
  let appendPath = '';
  return route.path.split('/')
    .map((part, index) => {
      appendPath += index === 0 ? '' : `/${part}`;
      const resolvedRoute = router.resolve(appendPath);
      const hasRoute = resolvedRoute ? router.hasRoute(resolvedRoute.name!) : false;
      return hasRoute
        ? {
            title: index === 0 ? '' : resolvedRoute.meta.breadcrumbName ?? part,
            to: appendPath,
            disabled: !hasRoute || resolvedRoute.meta.breadcrumbDisabled
          }
        : { title: part, disabled: true };
    })
});

</script>

<style scoped lang="scss">
.home-btn {
  background-color: $page-background-color;
}
</style>